<ng-container
  *ngIf="{
    isAuth: isAuth$ | async,
    userAuthInfo: userAuthInfo$ | async
  } as vm"
>
  <header class="z-50 w-full bg-white shadow-xl">
    <div class="flex max-h-16 items-center justify-between gap-2 px-6 py-4 lg:gap-4">
      <div class="logo relative">
        <h3 class="text-base font-medium text-slate-500" i18n>
          Admin Login As: <span class="font-bold">{{ vm.userAuthInfo?.fullname }}</span>
        </h3>
      </div>
      <div class="flex items-center gap-4">
        <div *ngIf="vm.isAuth" class="language relative">
          <button class="btn btn-primary btn-sm w-full" (click)="logout()" i18n>Logout</button>
        </div>
      </div>
    </div>
  </header>
</ng-container>
